import { useMemo } from "react";
import { DataSubscription } from "../../../model";
import { useDataChannel, useLoosePermissionChecker } from "../../../hooks";
import { Dashboard } from "capitalrx-types";

/**
 * Returns all the menu items, filtered by available permissions.
 */
export function useMenuItems(): ReadonlyArray<DataSubscription<Dashboard.NavigationItem>> {

  const checkLoosePermissions = useLoosePermissionChecker();
  const items = useDataChannel<Dashboard.NavigationItem>(null, "app-navigation");

  return useMemo(() => items.filter((item) => {
    const { data } = item;
    const { permissions } = data;

    if (permissions) return checkLoosePermissions(permissions);
    return true;
  }), [items, checkLoosePermissions]);
}
